import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { contentHeaders, apiBaseUrl } from "../common/config/config";
import { ActionSheetController, Platform, LoadingController, ToastController, AlertController } from "@ionic/angular";
import { Preferences } from "@capacitor/preferences";
import { Camera } from "@capacitor/camera";
import { Device } from "@capacitor/device";
import { Filesystem } from "@capacitor/filesystem";
import { VoiceRecorder } from "capacitor-voice-recorder";
import { NativeSettings, AndroidOptions, AndroidSettings } from "capacitor-native-settings";
import { App } from "@capacitor/app";
import { CompanyService } from "./company";
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
import { ScreenOrientation } from '@capacitor/screen-orientation';

//declare var Peer: any;
let apiUrl = apiBaseUrl + "users/";
// import { NativeMarket } from "@capgo/native-market";
import { CameraPreview } from '@capacitor-community/camera-preview';
@Injectable({
  providedIn: 'root'
})
export class UserService {
  public res: { status: { code: any; message: any }; data: any };
  public mobile: any;
  public name: any;
  public userType: any;
  public branchId;
  public allApps: any;
  public allCompany: any;
  public details = [];
  public appUserId;
  loader: any;
  flag = false;
  public appState = "";
  public status = "";
  public device: any;
  public platform: any;

  public locale = "en-US";
  public rate = 0.9;
  public pRC = 0;
  public camera = false;
  public uuid: any;
  public location: any;
  public screenWidth = 0;
  public screenHeight = 0;
  public keyboardHeight = 0;
  public isNetwork = true;
  public currentAppVersion = "19";
  isKeyboardHide = true;
  appPaused = false;
  public cameraPermission = false;
  public onScreenNavigation = false;
  public micPermission = false;
  public filePermission = false;
  public locationPermission = false;
  public otp: any;
  public headers: any;
  public language = "english";
  public currentPage = '';
  public branch: any;
  public temp = 0;
  public appType: any;
  public appKey: any;
  public exitReady = false;
  public alertPersent = false;
  public companyId: any;
  public updateApps = false;
  constructor(
    public http: HttpClient,
    private insuranceCompany: CompanyService,
    public actionSheetController: ActionSheetController,
    public loadingCtrl: LoadingController,
    public toaster: ToastController,
    public alertCtrl: AlertController,
    public androidPermissions: AndroidPermissions,
    public geolocation: Geolocation,
    public locationAccuracy: LocationAccuracy,
    public ionicPlatform: Platform
  ) {
    this.headers = contentHeaders;
    this.location = {
      lat: "",
      lng: "",
      timestamp: ""
    };
    if (this.ionicPlatform.is('capacitor') || this.ionicPlatform.is('cordova')) {
      if (this.ionicPlatform.is('ios')) this.platform = 'ios';
      else this.platform = 'android';
    } else {
      this.platform = 'web';
    }
  }
  async permissions() {
    return new Promise<boolean>(async (resolve, reject) => {
      // alert("Welcome ! \n Please allow all necessary permissions for smooth functioning of app");
      this.device = await Device.getInfo();
      let a = await this.getFilePermission();
      let b = await this.getLocationPermission();
      let c = await this.getCameraPermission();
      let d = await this.getMicPermission();
      // let e = await this.fileCamPermissions();
      if (this.locationPermission && this.cameraPermission && this.micPermission) {
        console.log("all permissions allowed");
        this.getCurrentLocation();
        resolve(true);
      } else {
        resolve(false);
        alert("Please provide all permissions for working App properly.")
        // NativeSettings.openAndroid({ option: AndroidSettings.Application });
      }
    });
  }
  // fileCamPermissions() {
  //   return new Promise<boolean>((resolve, reject) => {
  //     var t = this;
  //     Camera.checkPermissions().then((ape) => {
  //       console.log("requestPermissions CAMERA res", ape);
  //       if(ape.photos && ape.photos == "granted"){
  //         resolve(true);
  //       }
  //       else {
  //         Camera.requestPermissions({ permissions: ['photos'] }).then((s) => {
  //           console.log("checkPermission CAMERA res", s);
  //           if (s.photos && s.photos == "granted") {
  //             resolve(true);
  //           }
  //           else resolve(false);
  //         }, err => {
  //           console.log("checkPermission photos err", err);
  //           resolve(false);
  //         }).catch((e) => { 
  //           console.log("checkPermission photos catch", e);
  //           resolve(false); 
  //         });
  //       }
  //     }).catch(e => {
  //       console.log("requestPermissions photos catch", e);
  //       resolve(false);
  //     });
  //   });
  // }

  getMicPermission() {
    return new Promise<boolean>((resolve, reject) => {
      var t = this;
      VoiceRecorder.hasAudioRecordingPermission().then((ape) => {
        console.log("requestPermissions RECORD_AUDIO res", ape);
        if ((ape.value && ape.value == true) || (ape['voice recording'] && ape['voice recording'] == "granted")) {
          t.micPermission = true
          resolve(true);
        }
        else {
          VoiceRecorder.requestAudioRecordingPermission().then((s) => {
            console.log("checkPermission RECORD_AUDIO res", s);
            if ((s.value && s.value == true) || (s['voice recording'] && s['voice recording'] == "granted")) {
              t.micPermission = true;
              resolve(true);
            }
            else resolve(false);
          }, err => {
            console.log("checkPermission RECORD_AUDIO err", err);
            resolve(false);
          }).catch((e) => {
            console.log("checkPermission RECORD_AUDIO catch", e);
            resolve(false);
          });
        }
      }).catch(e => {
        console.log("requestPermissions RECORD_AUDIO catch", e);
        resolve(false);
      });
    })
  }
  getFilePermission() {
    return new Promise<boolean>((resolve, reject) => {
      var t = this;
      Filesystem.checkPermissions().then((ape) => {
        console.log("requestPermissions file res", ape);
        if (ape.publicStorage && ape.publicStorage == "granted") {
          t.filePermission = true;
          resolve(true);
        }
        else {
          Filesystem.requestPermissions().then((s) => {
            console.log("checkPermission file res", s);
            if (s.publicStorage && s.publicStorage == "granted") {
              t.filePermission = true;
              resolve(true);
            }
            else resolve(false);
          }, err => {
            console.log("checkPermission file err", err);
            // alert("Please open app settings and give Write to Storage permissions to use app. WSE:1");
            resolve(false);
          }).catch((e) => {
            console.log("checkPermission file catch", e);
            // alert("Please open app settings and give Write to Storage permissions to use app. WSE:2"); 
            resolve(false);
          });
        }
      }).catch(e => {
        console.log("requestPermissions file catch", e);
        resolve(false);
      });
    });
  }
  getCameraPermission() {
    return new Promise<boolean>((resolve, reject) => {
      if (this.ionicPlatform.is('cordova')) {
        var t = this;
        Camera.checkPermissions().then((ape) => {
          console.log("requestPermissions CAMERA res", ape);
          if (ape.camera && ape.camera == "granted") {
            t.cameraPermission = true;
            resolve(true);
          }
          else {
            Camera.requestPermissions().then((s) => {
              console.log("checkPermission CAMERA res", s);
              if (s.camera && s.camera == "granted") {
                t.cameraPermission = true;
                resolve(true);
              }
              else resolve(false);
            }, err => {
              console.log("checkPermission CAMERA err", err);
              // alert("Please open app settings and give Write to Storage permissions to use app. WSE:1");
              resolve(false);
            }).catch((e) => {
              console.log("checkPermission CAMERA catch", e);
              // alert("Please open app settings and give Write to Storage permissions to use app. WSE:2"); 
              resolve(false);
            });
          }
        }).catch(e => {
          console.log("requestPermissions CAMERA catch", e);
          resolve(false);
        });
      } else {
        this.cameraPermission = true;
        resolve(true);
      }
    });
  }
  // getLocationPermission() {
  //   return new Promise<boolean>((resolve, reject) => { 
  //     var t = this;
  //     Geolocation.checkPermissions().then(async (ape) => {
  //       console.log("requestPermissions Location res", ape);
  //       if(ape.location && ape.location == "granted"){
  //         t.locationPermission = true;
  //         await this.getCurrentLocation();
  //         resolve(true);
  //       }
  //       else {
  //         Geolocation.requestPermissions().then(async (s) => {
  //           console.log("checkPermission Location res", s);
  //           if (s.location && s.location == "granted") {
  //             t.locationPermission = true;
  //             await this.getCurrentLocation();
  //             resolve(true);
  //           }
  //           else resolve(false);
  //         }, err => {
  //           console.log("checkPermission Location err", err);
  //           alert("Please turn on device gps and try again");
  //           // alert("Please open app settings and give Write to Storage permissions to use app. WSE:1");
  //           resolve(false);
  //         }).catch((e) => { 
  //           console.log("checkPermission Location catch", e);
  //           alert("Please turn on device gps and try again");
  //           // alert("Please open app settings and give Write to Storage permissions to use app. WSE:2"); 
  //           resolve(false); 
  //         });
  //       }
  //     }).catch(e => {
  //       alert("Please turn on device gps and try again");
  //       console.log("requestPermissions Location catch", e);
  //       resolve(false);
  //     });
  //   });
  // }
  // async getCurrentLocation() {
  //   return new Promise<boolean>((resolve, reject) => {
  //     Geolocation.getCurrentPosition({
  //       maximumAge: 3000,
  //       timeout: 5000,
  //       enableHighAccuracy: true,
  //     }).then((resp) => {
  //       let timestamp = Date.now();
  //       this.location = { 
  //         lat: resp.coords.latitude,
  //         lng: resp.coords.longitude,
  //         timestamp: timestamp
  //       }
  //       resolve(true);
  //     }).catch(async (error) => {
  //       alert("Please turn on device gps and try again");
  //       console.log("Error getting location", error);
  //       reject(false);
  //     });
  //   });
  // }
  getLocationPermission() {
    return new Promise<boolean>((resolve, reject) => {
      if (this.ionicPlatform.is('cordova')) {
        this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION).then(async (result) => {
          if (result.hasPermission) {
            this.locationPermission = true;
            await this.requestToSwitchOnGPS();
            resolve(true);
          } else {
            this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION).then(async () => {
              this.locationPermission = true;
              await this.requestToSwitchOnGPS();
              resolve(true);
            }, (error) => {
              console.log("requestPermissions Location error", error);
              resolve(false);
            }).catch(e => {
              console.log("requestPermissions Location catch", e);
              resolve(false);
            })
          }
        }, (err) => {
          console.log("checkPermissions Location error", err);
          resolve(false);
        }).catch(e => {
          console.log("checkPermissions Location catch", e);
          resolve(false);
        });
      } else {
        // For non-Cordova environments (e.g., browser), assume permission is handled by the browser
        // or just resolve true so the app can proceed to try getting location via Geolocation API
        this.locationPermission = true;
        resolve(true);
      }
    });
  }
  requestToSwitchOnGPS() {
    if (this.ionicPlatform.is('cordova')) {
      this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(() => { this.getCurrentLocation(); },
        (error) => console.log(JSON.stringify(error))
      ).catch((error) => console.log(JSON.stringify(error)));
    } else {
      // In browser, we can't force GPS on, just try to get location
      this.getCurrentLocation();
    }
  }
  getCurrentLocation() {
    return new Promise<boolean>((resolve, reject) => {
      this.geolocation.getCurrentPosition().then((response) => {
        this.location.lat = response.coords.latitude;
        this.location.lng = response.coords.longitude;
        this.location.timestamp = response.timestamp;
        resolve(true);
      }).catch((err) => {
        console.log("Error getting location", err);
        // alert("Please turn on device gps and try again");
        reject(false);
      });
    });
  }
  auth(data) {
    if (data.toString().length <= 10) data = "91" + data;
    return new Promise((resolve, reject) => {
      this.http.post(apiUrl, { mobileNumber: data, version: this.currentAppVersion }, { headers: this.headers }).subscribe((res) => {
        resolve(res);
      }, (err) => {
        console.log("response", JSON.stringify(err));
        reject(err);
      });
    });
  }
  getTime() {
    return new Promise((resolve, reject) => {
      this.http.get("https://newapi.livechek.com").subscribe((res) => {
        console.log(res);
        resolve(res['headers']);
      }, (err) => {
        console.log(err);
        reject(err);
      });
    });
  }
  getAllCompanies() {
    this.insuranceCompany.getAll().then((res) => {
      this.allCompany = res;
      console.log(this.allCompany, "compan");
    });
  }
  updateFCMToken(token) {
    this.http.put(apiUrl + this.appUserId + "/FCMToken", { "token": token, "user": this.appUserId }, { headers: this.headers }).subscribe((res) => {
      console.log("updated successfully", res);
    });
  }

   getAllNotif(){
    return new Promise((resolve, reject) => {
      this.http.get(apiBaseUrl + "raven/" + this.appUserId+"/notifications").subscribe(async(res) => {
        console.log(res);
        if(res && res['data'] && res['data'].length > 0 ){
          resolve(res['data']);
        } else {
          resolve("false");
        } 
      }, (err) => {
        console.log(err);
        resolve("false");
      });
    });
  }
  getAllApps() {
    this.http.get(apiBaseUrl + "apps/", { headers: this.headers }).subscribe((res) => {
      this.allApps = res['data'];
    });
  }
  async saveToNativeStorage() {
    await this.getAllApps();
    await this.getAllCompanies();
    let userData = {
      mobile: this.mobile,
      name: this.name,
      appState: this.appState,
      companyId: this.companyId,
      branchId: this.branchId,
      appKey: this.appKey,
      status: this.status,
      allApps: this.allApps,
      baseUrl: apiBaseUrl,
      details: this.details,
      allCompany: this.allCompany,
      language: this.language,
      appType: this.appType,
      appUserId: this.appUserId,
    };
    // await this.fileDog.createUserInfoTextFile(userData);

    //  await Preferences.set({ key: "user", value: JSON.stringify(userData) })
    localStorage.setItem("user", JSON.stringify(userData));
  }
  setLocale(data) {
    if (data && data[0].others) {
      var index = data.findIndex((o) => o.others.value == this.language);
      if (index >= 0) {
        this.locale = data[index].others.locale;
        this.rate = data[index].others.rate;
      }
    }
  }
  checknet() {
    return new Promise((resolve, reject) => {
      this.http.get("https://google.com").subscribe((res) => {
        resolve(res);
      }, (err) => {
        reject(err);
      });
    });
  }
  verifyOTP(data) {
    return new Promise((resolve, reject) => {
      this.http.post(apiUrl + data.mobile + "/auth?type=otp", data, { headers: this.headers }).subscribe((res) => {
        resolve(res);
      }, (err) => {
        reject(err);
      });
    });
  }
  async showLoader(text?) {
    this.loader = await this.loadingCtrl.create({
      message: text ? text : 'Loading ...',
      spinner: 'crescent',
      backdropDismiss: true
    });

    if (!this.flag) { this.flag = true; await this.loader.present(); }
  }
  async hideLoader() {
    if (this.flag) await this.loader.dismiss();
    this.flag = false;
  }
  async logout() {
    //this.user = null;

    // await Preferences.remove({ key: 'inProcess' });
    // await Preferences.remove({ key: 'startTime' });
    // await Preferences.remove({ key: 'user' });


    localStorage.removeItem('user');
    localStorage.removeItem('inProcess');
    localStorage.removeItem('startTime');
    this.mobile = null;
  }
  validateUser() {
    return new Promise((resolve, reject) => {
      this.http.get(apiUrl + "" + this.appUserId).subscribe(async (res) => {
        if (res && res['data'] && res['data'][0]._id && res['data'][0].logOut && res['data'][0].logOut != false) {
          resolve('out');
        }
        else if (res && res['data'] && res['data'][0]._id && res['data'][0].status && res['data'][0].status == 'active') {
          this.saveToNativeStorage();
          this.name = res['data'][0].name;
          this.status = res['data'][0].status;
          this.details = res['data'][0].details;
          this.companyId = res['data'][0].companyId;
          this.branchId = res['data'][0].branchId;
          this.appType = res['data'][0].apps;
          resolve(true);
        } else {
          resolve(false);
        }
      }, (err) => {
        console.log(err);
        resolve(true);
      });
    });
  }
  getUserLocationFromIP(ip) {
    return new Promise((resolve, reject) => {
      this.http.get(apiBaseUrl + "ip_locations/").subscribe((res) => {
        resolve(res);
      }, (err) => {
        reject(err);
      });
    });
  }
  async closeApp() {
    if (this.exitReady) {
      this.exitReady = false;
      this.appCloseConfirm();
    } else {
      this.exitReady = true;
      let toast = await this.toaster.create({
        message: "Press Again to Confirm Exit",
        duration: 3000,
      });
      await toast.present();
      setTimeout(() => {
        this.exitReady = false;
      }, 2000);
    }
  }
  async appCloseConfirm() {
    let alert = await this.alertCtrl.create({
      header: "Do you want to close the app?",
      buttons: [
        {
          text: "No",
          role: "cancel",
          handler: () => {
            console.log("Cancel clicked");
            this.exitReady = false;
            this.alertPersent = false;
          },
        },
        {
          text: "Yes",
          handler: async () => {
            console.log("Impact confirmed");
            this.alertPersent = false;
            if (this.camera) {
              try {
                if (this.platform === 'web') {
                  // Web camera stop logic is handled in individual pages
                } else {
                  CameraPreview.stop();
                }
              } catch (error) {

              }
            }
            await App.exitApp();
          },
        },
      ],
    });
    if (this.alertPersent) { console.log("alresdt fjkgldf"); }
    else {
      this.alertPersent = true;
      await alert.present();
    }

  }
  getSubAgents(company, user) {
    return new Promise((resolve, reject) => {
      this.headers.set("company-id", company);
      this.headers.set("parent-id", user);
      this.http.get(apiUrl, { headers: this.headers }).subscribe((res) => {
        resolve(res['data']);
      }, (err) => {
        console.log("response", JSON.stringify(err));
        reject(err);
      });
    });
  }
  updateLogs(logs) {
    return new Promise((resolve, reject) => {
      this.http.put(apiUrl + this.appUserId + "/logs", logs, { headers: this.headers }).subscribe(async (res) => {
        console.log(res);
        if (res && res['data']) {
          resolve(true);
        } else {
          resolve(false);
        }
      }, (err) => {
        console.log(err);
        resolve(true);
      });
    });
  }
  async openFullscreen(type) {
    const elem = document.documentElement as any;
    try {
      if (elem.requestFullscreen) {
        await elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        await elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        await elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        await elem.msRequestFullscreen();
      }
      await ScreenOrientation.unlock();
      await ScreenOrientation.lock({ orientation: type });
    } catch (error) {
      console.log("can not roteate screen", error);
    }
  }
  async checkOrientationPermission() {
    if (this.platform !== 'web') {
      try {
        await ScreenOrientation.unlock();
        const toast = await this.toaster.create({
          message: 'Screen orientation unlocked.',
          duration: 2000,
          position: 'bottom'
        });
        await toast.present();
      } catch (e) {
        console.error('Capacitor ScreenOrientation unlock failed:', e);
        const alert = await this.alertCtrl.create({
          header: 'Orientation Permission',
          message: 'This app needs permission to change screen orientation. Please enable it in the app settings.',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel'
            },
            {
              text: 'Open Settings',
              handler: () => {
                NativeSettings.openAndroid({ option: AndroidSettings.ApplicationDetails });
              }
            }
          ]
        });
        await alert.present();
      }
    } else {
      // Web API for screen orientation
      console.log('Screen orientation control is managed by the browser on the web.');
    }
  }
}
